import ResellerSelection from "~/components/ResellerSelection";
import { getCommonSliceProps } from "~/external/prismic";
import { mapProperties } from "~/external/v2/prismic";
import { ResellerDocument } from "~/external/v2/types";
import connectSlice from "~/lib/connectSlice";

function mapSliceToProps(slice) {
  const { primary, items, merged } = slice;

  // console.log('MERGED', merged);

  const props = {
    ...getCommonSliceProps(slice),
    columnsOnDesktop: primary.columns_on_desktop || 4,
    columnsOnMobile: primary.columns_on_mobile || 2,
    resellers: items
      .filter(
        (item) => item.reseller && item.reseller.data && item.reseller.data.active
      )
      .map((item) => mapProperties(item.reseller, "reseller") as ResellerDocument),
    merged,
  };

  return props;
}

export default connectSlice(mapSliceToProps)(ResellerSelection);
